import React from "react";
import { Link } from "react-router-dom";
import { SocialLinks } from "./SocialLinks";
import { useSettings } from "../context/SettingsContext";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

export const Footer = () => {
  const { settings } = useSettings();
  const { t } = useLang();
  const { user } = useAuth();
  return (
    <footer className="border-t-2 border-brand-ink bg-brand-forest text-brand-cream">
      <div className="mx-auto max-w-7xl px-5 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="font-display text-4xl font-bold lowercase tracking-tight text-brand-yellow">panda tata</div>
            <p className="mt-3 max-w-xs text-sm text-brand-cream/70">{t("brand_slogan")}</p>
            <div className="mt-5">
              <p className="mb-3 text-xs font-bold uppercase tracking-widest text-brand-green">{t("follow_us")}</p>
              <SocialLinks settings={settings} dark />
            </div>
          </div>
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-widest text-brand-green">Menu</p>
            <ul className="space-y-2 text-sm text-brand-cream/80">
              <li><Link to="/story" className="hover:text-brand-yellow">{t("nav_story")}</Link></li>
              <li><Link to="/products" className="hover:text-brand-yellow">{t("nav_products")}</Link></li>
              <li><Link to="/franchise" className="hover:text-brand-yellow">{t("nav_franchise")}</Link></li>
              <li><Link to="/news" className="hover:text-brand-yellow">{t("nav_news")}</Link></li>
              <li><Link to="/contact" className="hover:text-brand-yellow">{t("nav_contact")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-widest text-brand-green">Account</p>
            <ul className="space-y-2 text-sm text-brand-cream/80">
              {user ? (
                <>
                  <li><Link to={user.role === "admin" ? "/admin" : "/member"} className="hover:text-brand-yellow">{user.role === "admin" ? t("nav_admin") : t("nav_member")}</Link></li>
                </>
              ) : (
                <>
                  <li><Link to="/register" className="hover:text-brand-yellow">{t("nav_join")}</Link></li>
                  <li><Link to="/login" className="hover:text-brand-yellow">{t("nav_login")}</Link></li>
                </>
              )}
            </ul>
            {settings.email_contact && (
              <p className="mt-4 text-sm text-brand-cream/60">{settings.email_contact}</p>
            )}
          </div>
        </div>
        <div className="mt-12 border-t border-brand-cream/20 pt-6 text-xs text-brand-cream/50">
          © {new Date().getFullYear()} Panda Tata. Handmade fresh-baked burgers · Malaysia.
        </div>
      </div>
    </footer>
  );
};
